import { isEqual } from 'es-toolkit';
import { createSelectorCreator, lruMemoize } from 'reselect';

import getUserSelector from './getUserSelector';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';

export default createDeepEqualSelector([getUserSelector], (user = null) => {
  const region = user?.reporting?.access?.region || EMPTY_ARRAY;
  const countries = user?.reporting?.access?.countries || EMPTY_ARRAY;
  return {
    region,
    countries,
  };
});
